/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PostServiceProviderOrganizationAdminRequest } from '../../models/post-service-provider-organization-admin-request';
import { ServiceProviderOrganizationAdmin } from '../../models/service-provider-organization-admin';

export interface PostServiceProviderOrganizationAdmin$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
      body: PostServiceProviderOrganizationAdminRequest
}

export function postServiceProviderOrganizationAdmin(http: HttpClient, rootUrl: string, params: PostServiceProviderOrganizationAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceProviderOrganizationAdmin>> {
  const rb = new RequestBuilder(rootUrl, postServiceProviderOrganizationAdmin.PATH, 'post');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServiceProviderOrganizationAdmin>;
    })
  );
}

postServiceProviderOrganizationAdmin.PATH = '/service-provider/organizations/{organizationKey}/organization-admins';
